import React, { FC, useState, useEffect } from "react";
import JsonData from '../data/intro.json';
import { TypeProps } from "./types";

const Intro:FC<TypeProps> = ({content}) => {
    const [text, setText] = useState('');
    useEffect(() => {
        const data = JsonData;
        if(Object.keys(data).includes(content)) {
            setText(data[content as keyof typeof data]);
        }
        else {
            console.error(`'${content}' is not allowed`);
        }
        // eslint-disable-next-line
    }, []);
    return (
        <p>{text}</p>
    );
};

export default Intro;